import { useNavigate } from "react-router-dom";
import { PHONE_VERIFY, PHONE_UNVERIFY } from "../../apiEndpoints";
import usePutData from "../../../../CustomHooks/useAxios/usePutData";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";

const PhoneVerificationDialog = ({
  actionType,
  userID,
  closeDialog,
  userName,
}) => {
  const { executePut, loading, successResponse, formError, setFormError } =
    usePutData();

  const navigate = useNavigate();

  // user Verification API call
  const handlePhoneVerification = () => {
    const apiUrl = actionType
      ? `${PHONE_UNVERIFY}${userID}` // Un-verify
      : `${PHONE_VERIFY}${userID}`; // Verify

    executePut(apiUrl, {});
  };

  const btnText = actionType ? "Unverify" : "Verify";
  const loadingText = actionType ? "Unverifying..." : "Verifying...";
  const btnClass = actionType
    ? "bg-amber-600 hover:bg-amber-500"
    : "bg-teal-600 hover:bg-teal-500";

  return (
    <Modal
      onClose={successResponse || loading ? undefined : closeDialog}
      modalWidth={`${
        successResponse ? "max-w-sm" : "max-w-lg"
      } w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8`}
    >
      <>
        {successResponse ? (
          <div className="text-center">
            <img src={successIcon} alt="success" className="mx-auto w-9 mb-2" />
            <p className="py-5">
              User Successfully {actionType ? "Unverified" : "Verified"}
            </p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate(0)}
            />
          </div>
        ) : (
          <>
            {formError && (
              <ErrorDisplay
                message={formError}
                closeAction={() => setFormError("")}
              />
            )}
            <h2 className="text-xl font-figtreeBold mb-4">
              {actionType ? "Unverify" : "Verify"} Phone Number
            </h2>
            <p className="text-gray-700 mb-6">
              Are you sure you want to {actionType ? "Unverify" : "Verify"}
              <span className="font-medium text-black"> {userName}</span>?{" "}
              <br />
              {actionType
                ? "This action will stop OTP from being sent to the user’s phone number."
                : "This action will allow OTPs to be sent to the user’s phone number."}
            </p>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={closeDialog}
                className="px-4 py-2 rounded-lg border bg-dBlue-100 hover:bg-gray-200 text-dark-blue"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handlePhoneVerification}
                className={`px-4 py-2 rounded-lg text-white transition-colors ${btnClass}`}
                disabled={loading}
              >
                {loading ? loadingText : btnText}
              </button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
};

export default PhoneVerificationDialog;
